/** Market Signal and the Contracts board (GDD §3.9–3.10). */

/** Prices shift every this many seconds of game clock. */
export const MARKET_PERIOD = 2 * 3600;
export const MARKET_MIN = 0.6;
export const MARKET_MAX = 1.5;
/** One discovered resource per period is the Hot Contract. */
export const MARKET_HOT = 2.5;

export const CONTRACT_SLOTS = 3;
/** Seconds of game clock before an empty contract slot refills. */
export const CONTRACT_REFILL = 5 * 60;
/** Contract size in seconds-of-value: bigger asks for deeper items. */
export const CONTRACT_QTY_MIN = 3;
export const CONTRACT_QTY_MAX = 15;
